import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const greenhouse = defineConnector({
  identifier: "greenhouse",
  name: "Greenhouse",
  tagLine: "Hiring and recruiting software",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://harvest\\.greenhouse\\.io/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.apiKey,
      password: "",
    }),
  steps: [
    {
      title: "Get your Greenhouse API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to Greenhouse and navigate to **Configure > Dev Center > API Credential Management** to create a Harvest API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Harvest API Key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://harvest.greenhouse.io/v1/users",
  },
  publicEnvVars: () => ({
    GREENHOUSE_API_KEY: "{will-be-injected}",
  }),
  usageHint: () =>
    "Use the Harvest API v3 endpoints (https://harvest.greenhouse.io/v3/…); v1 and v2 are deprecated.",
});
